package com.iregained.eventapp.components.models

import kotlinx.serialization.Serializable

// Safe from the serialization compiler bug!
fun TimeSlotData.availableSpots(): Int = (capacity - bookedCount).coerceAtLeast(0)

fun TimeSlotData.isFull(): Boolean = availableSpots() == 0 || isBlocked

@Serializable
data class PatientIntakeFormState(
    var fullName: String = "",
    var email: String = "",
    var phone: String = "",
    var conditionNotes: String = "",
    var accommodations: String = "",
    var consentTransactional: Boolean = true,
    var consentMarketing: Boolean = false,
    var consentSms: Boolean = true
)